// extracted by mini-css-extract-plugin
module.exports = {"IR35FAQs":"styles_IR35FAQs__8WEZi","height":"styles_height__E5SJX"};